import type { JSX } from "react";
import { cn } from "./cn";

export interface ViewTab {
  readonly id: string;
  readonly label: string;
}

export interface ViewTabsProps {
  readonly tabs: readonly ViewTab[];
  readonly activeTab: string;
  readonly onTabChange: (tabId: string) => void;
  readonly title?: string;
}

/**
 * Pill-style view switcher tabs (e.g. Detail / Day / Week / Month).
 * Used in meetings, tasks, and other views with multiple sub-views.
 */
export function ViewTabs({ tabs, activeTab, onTabChange, title }: ViewTabsProps): JSX.Element {
  return (
    <div className="flex gap-2 items-center flex-wrap">
      {title ? <div className="text-base font-semibold mr-2">{title}</div> : null}
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={cn(
            "border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer",
            activeTab === tab.id
              ? "bg-surface-secondary text-content"
              : "bg-surface-hover text-content-secondary",
          )}
          type="button"
          onClick={() => { onTabChange(tab.id); }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
